module.exports = __webpack_public_path__ + "img/bandcamp.5b8f5fb0.svg";